import { Box } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { VStack, colors, Spacing } from "goi_common";
import LazyLoad from "goi_common/src/components/LazyLoad";
import { ReactNode } from "react";

interface HomeV4YoutubeSectionProps {
  title?: ReactNode;
  youtubeUrl?: string;
  quote?: ReactNode;
  description?: ReactNode;
  source?: ReactNode;
}

export default function HomeV4YoutubeSection({
  title = "누구에게라도 추천할 수 있어요",
  youtubeUrl = "https://www.youtube.com/embed/z9EyhkxlpKk?autoplay=1&mute=1&loop=1&playlist=z9EyhkxlpKk&rel=0&modestbranding=1",
  quote = <>&#34;나라면 저렇게 할 수 있었을까?&#34;</>,
  description = (
    <>
      장례 절차 모든 과정을 통해서 보여주셨던 진심이
      <br />
      유가족인 저에게 평생 잊지 못할 감동으로
      <br />
      다가왔습니다.
    </>
  ),
  source = "임정욱님 영상 인터뷰 중 일부 발췌",
}: HomeV4YoutubeSectionProps) {
  return (
    <VStack padding="80px 20px" width="100%" alignItems="center">
      <Box className="gray900 subtitle_21_sb" textAlign="center">
        {title}
      </Box>

      <Spacing gap={24} />

      <VStack width="100%" alignItems="center">
        <LazyLoad width="100%" height="100%" top={-400}>
          <IframeWrapper>
            <YoutubeIframe
              src={youtubeUrl}
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            />
          </IframeWrapper>
        </LazyLoad>
      </VStack>

      <Spacing gap={24} />

      <Box className="subtitle_18_sb" textAlign="center" color={colors.gray900}>
        {quote}
      </Box>

      <Spacing gap={4} />

      <Box className="body_14_r" textAlign="center" color={colors.gray600}>
        {description}
      </Box>

      <Spacing gap={16} />

      <Box className="body_14_r" color={colors.blue650} textAlign="center">
        {source}
      </Box>
    </VStack>
  );
}

const IframeWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  border-radius: 8px;
  overflow: hidden;
`;

const YoutubeIframe = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;
